<template>
  <div v-if="visible" class="dialog-overlay" >
  <!-- @click.self="handleClose" -->
    <div class="dialog-container">
      <!-- 头部 -->
      <div class="dialog-header">
        <h2 class="dialog-title">创建项目</h2>
        <div class="close-btn" @click="handleClose">
          <el-icon><Close /></el-icon>
        </div>
      </div>

      <!-- 内容 -->
      <div class="dialog-body">
        <!-- 项目名称 -->
        <div class="form-item">
          <label class="form-label">项目名称</label>
          <el-input
            v-model="form.projectName"
            placeholder="请输入短剧项目名称"
            class="dark-input"
          ></el-input>
        </div>

        <!-- 归属团队 -->
        <div class="form-item">
          <label class="form-label">归属团队</label>
          <el-select
            v-model="form.teamId"
            placeholder="请选择团队"
            class="dark-select"
            clearable
            :loading="teamLoading"
          >
            <el-option
              v-for="team in teamList"
              :key="team.id"
              :label="team.teamName"
              :value="team.id"
            />
          </el-select>
        </div>

        <!-- 叙事模式 -->
        <div class="form-item">
          <label class="form-label">叙事模式</label>
          <div class="mode-options">
            <div
              class="mode-option"
              :class="{ active: form.narrativeMode === '剧情模式' }"
              @click="form.narrativeMode = '剧情模式'"
            >
              <el-icon><Film /></el-icon>
              <span>剧情模式</span>
              <el-tooltip
                class="mode-tooltip"
                content="70% 以上为对话场景，适合 AI短剧、情景喜剧、角色扮演"
                placement="top"
              >
                <el-icon class="question-icon"><QuestionFilled /></el-icon>
              </el-tooltip>
            </div>
            <div
              class="mode-option"
              :class="{ active: form.narrativeMode === '旁白解说模式' }"
              @click="form.narrativeMode = '旁白解说模式'"
            >
              <el-icon><Microphone /></el-icon>
              <span>旁白解说模式</span>
              <el-tooltip
                class="mode-tooltip"
                content="适合解说类短剧，具有完整的叙述框架"
                placement="top"
              >
                <el-icon class="question-icon"><QuestionFilled /></el-icon>
              </el-tooltip>
            </div>
          </div>
        </div>

        <!-- 比例 / 风格 -->
        <div class="form-item">
          <label class="form-label">项目参数 <span class="required-mark">*</span></label>
          <div class="form-item-row form-item-row-inline">
            <el-select
              v-model="form.videoRatio"
              placeholder="请选择视频比例"
              class="dark-select"
            >
              <el-option
                v-for="ratio in ratioOptions"
                :key="ratio.value"
                :label="ratio.label"
                :value="ratio.label"
              >
                <div class="ratio-option">
                  <div class="ratio-icon-wrap">
                    <div class="ratio-icon" :class="ratio.value"></div>
                  </div>
                  <span>{{ ratio.label }}</span>
                </div>
              </el-option>
            </el-select>
            <el-select
              v-model="form.styleId"
              placeholder="请选择风格"
              class="dark-select"
              filterable
              :loading="styleLoading"
            >
              <el-option
                v-for="style in styleOptions"
                :key="style.id"
                :label="style.content"
                :value="style.id"
              >
                <div class="style-option">
                  <img v-if="style.icon" class="style-option-icon" :src="style.icon" alt="" />
                  <span>{{ style.content }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 剧本导入 -->
        <div class="form-item">
          <div class="form-label-row">
            <label class="form-label">
              剧本导入
            </label>
            <div class="model-switch">
              <div
                class="model-switch-item"
                :class="{ active: form.model === 'deepseek' }"
                @click="form.model = 'deepseek'"
              >
                DeepSeek
              </div>
              <div
                class="model-switch-item"
                :class="{ active: form.model === 'doubao' }"
                @click="form.model = 'doubao'"
              >
                豆包
              </div>
            </div>
          </div>
          <div class="script-textarea-wrapper">
            <el-input
              v-model="form.script"
              type="textarea"
              :rows="6"
              placeholder="请导入剧本，将为你自动分集（文本请用第n章/集分割）"
              class="dark-textarea"
              :maxlength="SCRIPT_MAX_LENGTH"
              @input="handleScriptInput"
              @paste="handleScriptPaste"
            ></el-input>
            <div class="script-actions">
              <div class="script-action-btn" @click="handleDownloadTemplate">
                <el-icon><Download /></el-icon>
                <span>下载标准模板</span>
              </div>
              <div
                v-if="!form.juben"
                class="script-action-btn"
                :class="{ disabled: uploadLoading }"
                @click="handleUploadScript"
              >
                <el-icon :class="{ 'is-loading': uploadLoading }">
                  <Loading v-if="uploadLoading" />
                  <Upload v-else />
                </el-icon>
                <span>{{ uploadLoading ? "上传中" : "上传剧本" }}</span>
              </div>
              <div v-else class="script-file-tag">
                <span class="script-file-name" :title="form.jubenName">{{ form.jubenName }}</span>
                <span v-if="recognizeLoading" class="script-file-recognizing">
                  <el-icon class="is-loading"><Loading /></el-icon>
                  识别中...
                </span>
                <el-icon
                  class="script-file-remove"
                  :class="{ disabled: recognizeLoading }"
                  @click="handleRemoveScript"
                >
                  <Delete />
                </el-icon>
              </div>
            </div>
            <input
              ref="scriptFileInput"
              type="file"
              accept=".doc,.docx,.txt,.pdf"
              style="display: none"
              @change="onScriptFileChange"
            />
            <div class="char-count">{{ form.script.length }} / {{ SCRIPT_MAX_LENGTH }}</div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <el-button class="cancel-btn" @click="handleClose">取消</el-button>
        <el-button
          class="submit-btn"
          :loading="loading || recognizeLoading"
          :disabled="loading || recognizeLoading"
          @click="handleSubmit"
        >
          {{ recognizeLoading ? "剧本识别中..." : loading ? "创建中..." : "立即创建" }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElLoading } from "element-plus";
import {
  Close,
  Film,
  Microphone,
  QuestionFilled,
  MagicStick,
  Download,
  Upload,
  Delete,
  Loading,
} from "@element-plus/icons-vue";
import { EventBus, EVENTS } from "@/utils/eventBus";
import scriptTemplateUrl from "@/utils/Script template.docx";
import {
  ainewProjectadd,
  ainewProjectChapteradd,
  ainewProjectChapterlist,
  ainewChapterScriptadd,
  teamMyCreatedTeams,
  getupload,
  ainewPlatformStylelist,
  aizhipufile,
} from "@/api/index";

defineOptions({
  name: "CreateProjectDialog",
});

const router = useRouter();
const visible = ref(false);
const loading = ref(false);
const teamList = ref([]);
const teamLoading = ref(false);
const styleOptions = ref([]);
const styleLoading = ref(false);
const ratioOptions = [
  { label: "16:9", value: "ratio-16-9" },
  { label: "9:16", value: "ratio-9-16" },
  { label: "4:3", value: "ratio-4-3" },
  { label: "3:4", value: "ratio-3-4" },
];
const SCRIPT_MAX_LENGTH = 50000;
const form = reactive({
  projectName: "",
  teamId: null,
  narrativeMode: "drama",
  videoRatio: "",
  styleId: null,
  script: "",
  juben: "",
  jubenName: "",
  model: "deepseek",
});
const uploadLoading = ref(false);
const recognizeLoading = ref(false);
const scriptFileInput = ref(null);

function truncateScriptText(text) {
  return String(text ?? "").slice(0, SCRIPT_MAX_LENGTH);
}

function setScriptText(text) {
  form.script = truncateScriptText(text);
}

function handleScriptInput(value) {
  const normalized = truncateScriptText(value);
  if (normalized !== value) {
    form.script = normalized;
  }
}

function handleScriptPaste(e) {
  const pasted = e.clipboardData?.getData("text") ?? "";
  if (!pasted) return;

  const textarea = e.target;
  const current = form.script || "";
  const start = textarea.selectionStart ?? current.length;
  const end = textarea.selectionEnd ?? current.length;
  const next = `${current.slice(0, start)}${pasted}${current.slice(end)}`;

  if (next.length > SCRIPT_MAX_LENGTH) {
    e.preventDefault();
    form.script = truncateScriptText(next);
  }
}

function fetchTeamList() {
  teamLoading.value = true;
  teamMyCreatedTeams({
    pageNum: 1,
    pageSize: 999,
  })
    .then((res) => {
      if (res.code === 200) {
        const rows = Array.isArray(res.rows)
          ? res.rows
          : Array.isArray(res.data)
          ? res.data
          : [];
        teamList.value = rows;
      } else {
        teamList.value = [];
      }
    })
    .catch(() => {
      teamList.value = [];
    })
    .finally(() => {
      teamLoading.value = false;
    });
}

function fetchStyleList() {
  styleLoading.value = true;
  ainewPlatformStylelist({
    pageNum: 1,
    pageSize: 999,
    status: 1,
  })
    .then((res) => {
      if (res.code === 200) {
        styleOptions.value = Array.isArray(res.rows) ? res.rows : [];
      } else {
        styleOptions.value = [];
      }
    })
    .catch(() => {
      styleOptions.value = [];
    })
    .finally(() => {
      styleLoading.value = false;
    });
}

function show() {
  visible.value = true;
  resetForm();
  fetchTeamList();
  fetchStyleList();
}

function hide() {
  visible.value = false;
}

function resetForm() {
  form.projectName = "";
  form.teamId = null;
  form.narrativeMode = "剧情模式";
  form.videoRatio = "";
  form.styleId = null;
  form.script = "";
  form.juben = "";
  form.jubenName = "";
  form.model = "deepseek";
  recognizeLoading.value = false;
}

function handleClose() {
  visible.value = false;
}

function handleDownloadTemplate() {
  const link = document.createElement("a");
  link.href = scriptTemplateUrl;
  link.download = "AI创作剧本模板.docx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  ElMessage.success("剧本模板下载成功");
}

function handleUploadScript() {
  if (uploadLoading.value) return;
  scriptFileInput.value?.click();
}

async function onScriptFileChange(e) {
  const file = e.target.files?.[0];
  e.target.value = "";
  if (!file) return;

  if (file.size > 20 * 1024 * 1024) {
    ElMessage.warning("文件大小不能超过 20MB");
    return;
  }

  uploadLoading.value = true;
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await getupload(formData);
    if (res.code === 200) {
      form.juben = res.url || "";
      form.jubenName = file.name;
      ElMessage.success("剧本上传成功");
      recognizeScript(res.url);
    }
  } catch (error) {
    // 错误提示由 request 拦截器统一处理
  } finally {
    uploadLoading.value = false;
  }
}

async function recognizeScript(fileUrl) {
  if (!fileUrl) return;

  recognizeLoading.value = true;
  try {
    const res = await aizhipufile({ fileUrls: fileUrl });
    if (res.code === 200) {
      const text = res.data?.text ?? res.text ?? "";
      if (text) {
        setScriptText(text);
        ElMessage.success("剧本识别成功");
      } else {
        ElMessage.warning("未能识别剧本内容");
        form.juben = "";
        form.jubenName = "";
      }
    } else {
      form.juben = "";
      form.jubenName = "";
    }
  } catch (error) {
    form.juben = "";
    form.jubenName = "";
  } finally {
    recognizeLoading.value = false;
  }
}

function handleRemoveScript() {
  if (recognizeLoading.value) {
    ElMessage.warning("剧本识别中，请稍候");
    return;
  }
  form.juben = "";
  form.jubenName = "";
}

function handleAIGenerate() {
  ElMessage.info("AI正在生成剧本...");
  setTimeout(() => {
    form.script = truncateScriptText(`第1集：开篇

【场景：现代都市，繁华街道】

主角小明走在街上，手里拿着一封神秘的信...

第2集：转折

【场景：古老图书馆】

小明发现了一本古老的书籍，上面记载着惊人的秘密...`);
    ElMessage.success("剧本生成成功");
  }, 1500);
}

function handleSubmit() {
  if (recognizeLoading.value) return;

  if (!form.projectName.trim()) {
    ElMessage.warning("请输入项目名称");
    return;
  }

  if (!form.teamId) {
    ElMessage.warning("请选择归属团队");
    return;
  }

  if (!form.videoRatio) {
    ElMessage.warning("请选择视频比例");
    return;
  }

  if (!form.styleId) {
    ElMessage.warning("请选择风格");
    return;
  }

  if (!form.script.trim() && !form.juben) {
    ElMessage.warning("请上传剧本或者填写剧本内容");
    return;
  }

  loading.value = true;
  console.log(form);
  const loadingInstance = ElLoading.service({
    lock: true,
    text: "创建中...",
    background: "rgba(0, 0, 0, 0.7)",
  });

  ainewProjectadd({
    userId: localStorage.getItem("userId"),
    projectName: form.projectName,
    teamId: form.teamId,
    type: form.narrativeMode,
    scriptContent: form.script,
    juben: form.juben,
    videoRatio: form.videoRatio,
    styleId: form.styleId,
    model: form.model,
  }).then((res) => {
    loading.value = false;
    ElMessage.success("项目创建成功");
    visible.value = false;
    ainewProjectChapterlist({
      projectId: res.data.id,
      pageNum: 1,
      pageSize: 1,
    }).then((res1) => {
      if (res1.rows.length < 1) {
        ainewProjectChapteradd({
          projectId: res.data.id,
          chapterName: "第1章",
        }).then((res2) => {
          ainewChapterScriptadd({
            chapterId: res2.data.id,
            videoRatio: form.videoRatio,
            scriptContent: form.script,
          }).then(() => {
            loadingInstance.close();
            const newProjectId = res.data.id;
            router.push({
              name: "Editor",
              params: { id: newProjectId },
            });
          });
        });
      } else {
        loadingInstance.close();
        const newProjectId = res.data.id;
        router.push({
          name: "Editor",
          params: { id: newProjectId },
        });
      }
    });
  });
}

onMounted(() => {
  EventBus.$on(EVENTS.SHOW_CREATE_PROJECT, show);
  EventBus.$on(EVENTS.HIDE_CREATE_PROJECT, hide);
});

onBeforeUnmount(() => {
  EventBus.$off(EVENTS.SHOW_CREATE_PROJECT, show);
  EventBus.$off(EVENTS.HIDE_CREATE_PROJECT, hide);
});
</script>

<style lang="scss" scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.dialog-container {
  width: 560px;
  max-width: 90vw;
  max-height: 90vh;
  background-color: #1e1e1e;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #2d2d2d;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2d2d2d;
  }

  .el-icon {
    font-size: 18px;
    color: #888;
  }
}

.dialog-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.form-item {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.form-item-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;

  .form-item-half {
    flex: 1;
    margin-bottom: 0;
  }

  &.form-item-row-inline {
    margin-bottom: 0;

    .dark-select {
      flex: 1;
    }
  }
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 12px;

  .required-mark {
    color: #f56c6c;
    margin-left: 2px;
  }
}

.form-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  .form-label {
    margin-bottom: 0;
  }
}

.model-switch {
  display: flex;
  padding: 2px;
  background-color: #2d2d2d;
  border: 1px solid #3d3d3d;
  border-radius: 6px;
}

.model-switch-item {
  padding: 4px 12px;
  font-size: 12px;
  color: #888;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    color: #fff;
  }

  &.active {
    background-color: rgba(139, 255, 139, 0.15);
    color: #8bff8b;
    font-weight: 500;
  }
}

.ai-generate-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: transparent;
  border: 1px solid #8bff8b;
  border-radius: 6px;
  color: #8bff8b;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(139, 255, 139, 0.1);
  }

  .el-icon {
    font-size: 14px;
  }
}

.dark-input {
  :deep(.el-input__wrapper) {
    background-color: #2d2d2d;
    box-shadow: 0 0 0 1px #3d3d3d inset !important;
    border-radius: 8px;
    padding: 0 12px;
  }

  :deep(.el-input__inner) {
    color: #fff;
    height: 44px;
    font-size: 14px;
    caret-color: #8bff8b;

    &::placeholder {
      color: #666;
    }
  }

  :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #4d4d4d inset !important;
  }

  :deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 0 0 1px #8bff8b inset !important;
  }
}

.dark-select {
  width: 100%;

  :deep(.el-select__wrapper) {
    background-color: #2d2d2d;
    box-shadow: 0 0 0 1px #3d3d3d inset !important;
    border-radius: 8px;
    min-height: 44px;
  }

  :deep(.el-select__placeholder) {
    color: #666;
  }

  :deep(.el-select__selected-item) {
    color: #fff;
    font-size: 14px;
  }

  :deep(.el-select__wrapper:hover) {
    box-shadow: 0 0 0 1px #4d4d4d inset !important;
  }

  :deep(.el-select__wrapper.is-focused) {
    box-shadow: 0 0 0 1px #8bff8b inset !important;
  }
}

.mode-options {
  display: flex;
  gap: 16px;
}

.ratio-option {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ratio-icon-wrap {
  width: 28px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ratio-icon {
  border: 1.5px solid currentColor;
  border-radius: 2px;
  opacity: 0.85;

  &.ratio-16-9 {
    width: 22px;
    height: 12px;
  }

  &.ratio-9-16 {
    width: 12px;
    height: 20px;
  }

  &.ratio-4-3 {
    width: 18px;
    height: 14px;
  }

  &.ratio-3-4 {
    width: 14px;
    height: 18px;
  }
}

.style-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.style-option-icon {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
}

.mode-option {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 20px;
  background-color: #2d2d2d;
  border: 2px solid #3d3d3d;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #888;
  position: relative;

  &:hover {
    border-color: #4d4d4d;
    color: #fff;
  }

  &.active {
    border-color: #8bff8b;
    color: #fff;
    background-color: rgba(139, 255, 139, 0.05);
  }

  .el-icon:first-child {
    font-size: 18px;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }

  .question-icon {
    font-size: 14px;
    color: #666;
    cursor: help;

    &:hover {
      color: #888;
    }
  }
}

.script-textarea-wrapper {
  position: relative;
}

.dark-textarea {
  :deep(.el-textarea__inner) {
    background-color: #2d2d2d;
    border: 1px solid #3d3d3d;
    color: #fff;
    border-radius: 8px;
    padding: 12px;
    resize: none;
    font-size: 14px;
    caret-color: #8bff8b;
    line-height: 1.5;
    box-shadow: none;
    padding-bottom: 48px;

    &::placeholder {
      color: #666;
    }

    &:hover {
      border-color: #4d4d4d;
    }

    &:focus {
      border-color: #8bff8b;
      box-shadow: 0 0 0 2px rgba(139, 255, 139, 0.1);
    }
  }
}

.script-actions {
  position: absolute;
  bottom: 10px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
}

.script-action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background-color: #2d2d2d;
  border: 1px solid #4d4d4d;
  border-radius: 4px;
  color: #aaa;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  .el-icon {
    font-size: 14px;
  }

  &:hover {
    background-color: #3d3d3d;
    border-color: #666;
    color: #fff;
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.script-file-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 220px;
  padding: 4px 8px;
  background-color: #2d2d2d;
  border: 1px solid #4d4d4d;
  border-radius: 4px;
  color: #ccc;
  font-size: 12px;
  line-height: 1.2;
}

.script-file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.script-file-recognizing {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #8bff8b;
  font-size: 12px;

  .el-icon {
    font-size: 12px;
  }
}

.script-file-remove {
  flex-shrink: 0;
  font-size: 14px;
  color: #888;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #f56c6c;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.char-count {
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-size: 12px;
  color: #666;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #2d2d2d;
}

.cancel-btn {
  padding: 10px 24px;
  background-color: transparent;
  border: 1px solid #3d3d3d;
  color: #fff;
  border-radius: 8px;

  &:hover {
    background-color: #2d2d2d;
    border-color: #4d4d4d;
  }
}

.submit-btn {
  padding: 10px 24px;
  background-color: #8bff8b !important;
  border: none !important;
  color: #1a1a1a !important;
  border-radius: 8px;
  font-weight: 600;

  &:hover:not(:disabled) {
    background-color: #7aee7a !important;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
